import { Box } from '@mui/material'
import {
  SORWorkCentreSummaryTableProps,
  SORWorkcentreSummaryType,
} from './SORWorkCentreSummary.types'
import { useMemo } from 'react'
import { Table } from 'Common/MUITable/MUITable'
import {
  GridRowParams,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid-premium'
import { autoHeight } from 'Common/utils/utils'

const WCSummaryToolbar = ({ dataExists }: { dataExists: boolean }) => {
  return () => (
    <GridToolbarContainer>
      {dataExists && (
        <GridToolbarExport
          excelOptions={{
            allColumns: true,
            fileName: `published_wc_summary`,
          }}
          slotProps={{
            tooltip: { title: 'Download data' },
            button: { variant: 'outlined' },
          }}
        />
      )}
    </GridToolbarContainer>
  )
}

export const SORWorkcentreSummaryTable = ({
  isLoading,
  data,
  handleRowClick,
}: SORWorkCentreSummaryTableProps) => {
  const columns = useMemo(
    () => [
      {
        headerName: 'Work centre code',
        field: 'workCentreCode',
        flex: 1,
      },
      {
        headerName: 'Week',
        field: 'monday',
        flex: 1,
      },
      {
        headerName: 'Work centre key',
        field: 'workCentreKey',
        flex: 1,
      },
      {
        headerName: 'Status',
        field: 'status',
        flex: 1,
      },
    ],
    [data]
  )

  const dataExists = data && data.length > 0

  return (
    <Box id="#table-container-mui" display="flex" flex="auto">
      <Table
        ref={autoHeight}
        loading={isLoading}
        getRowId={(row) => {
          return row.workCentreKey
        }}
        rows={data ?? []}
        columns={columns}
        showCellVerticalBorder
        showColumnVerticalBorder
        pagination
        initialState={{
          pagination: { paginationModel: { pageSize: 100 } },
          rowGrouping: {
            model: ['status'],
          },
        }}
        pageSizeOptions={[25, 50, 100]}
        experimentalFeatures={{
          lazyLoading: true,
        }}
        defaultGroupingExpansionDepth={-1}
        onRowClick={(rowData: GridRowParams<SORWorkcentreSummaryType>) => {
          handleRowClick(rowData.row)
        }}
        localeText={{
          toolbarExport: 'Download',
        }}
        slots={{
          toolbar: WCSummaryToolbar({ dataExists }),
        }}
      />
    </Box>
  )
}
